import { render, staticRenderFns } from "./task-board.vue?vue&type=template&id=3f0b344e&scoped=true&"
import script from "./task-board.vue?vue&type=script&lang=js&"
export * from "./task-board.vue?vue&type=script&lang=js&"
import style0 from "./task-board.vue?vue&type=style&index=0&id=3f0b344e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0b344e",
  null
  
)

export default component.exports